module.exports = __webpack_public_path__ + "img/Fiddlre.80ee7d50.png";